<form [formGroup]="formGroup">
    <!-- <mat-form-field appearance="outline" class="form-group" [hidden]="!enabled">
        <mat-label>Branches</mat-label>
        <mat-select class="profile-inputs_c-grey-6" formControlName="country_tokens" multiple
            [class.loading-field]="loadingCountries" [required]="enabled">
            <ng-container *ngIf="List?.length > 1 else IndividualCountries">
                <mat-optgroup *ngFor="let item of List;let i = index" [label]="item.title">
                    <mat-option *ngFor="let country of item.list" [value]="country.country_token">
                        {{ country.countryName }}
                    </mat-option>
                </mat-optgroup>
            </ng-container>
            <ng-template #IndividualCountries>
                <mat-option *ngFor="let country of List[0]?.list" [value]="country.country_token">
                    {{ country.countryName }}
                </mat-option>
            </ng-template>
        </mat-select>
        <mat-error *ngIf="enabled ?
             formGroup?.get('country_tokens')?.invalid &&
             (formGroup?.get('country_tokens')?.touched || isSubmitted)
               :false">
            Is Required
        </mat-error>
    </mat-form-field> -->
    <mat-form-field appearance="outline" [hidden]="!enabled">
        <mat-label>Select Branches</mat-label>
        <mat-select formControlName="{{key}}" multiple [required]="enabled && isRequired">

            <div class="search-container"
                style="position: sticky; top: 0; background: white; z-index: 2; padding: 4px 8px;">
                <input class="w-100 form-control-sm" placeholder="Search countries..." [formControl]="searchControl"
                    (keydown)="$event.stopPropagation()">
            </div>

            <ng-container *ngIf="original_branches?.length  else IndividualCountries">
                <mat-optgroup *ngFor="let group of groupedData" [label]="group.title" [hidden]="notHaveList(group?.id)">
                    <mat-option *ngFor="let item of group?.list" [value]="item?.country_token"
                        [hidden]="notIncludedInFilteredList(item?.country_token)">
                        {{ item?.countryName }}
                    </mat-option>
                </mat-optgroup>
            </ng-container>
            <ng-template #IndividualCountries>
                <mat-option *ngFor="let item of getListInFilter" [value]="item?.country_token"
                    [hidden]="notIncludedInFilteredList(item?.country_token)">
                    {{ item?.countryName }}
                </mat-option>
            </ng-template>

            <div *ngIf="filteredGroupedData?.length === 0"
                style="padding: 16px; font-size: 14px; color: rgba(0, 0, 0, 0.54); text-align: center;">
                No matches found
            </div>

        </mat-select>
        <mat-error
            *ngIf="enabled ? formGroup?.get(key)?.invalid && (formGroup?.get(key)?.touched || isSubmitted) : false">
            field is required
        </mat-error>
    </mat-form-field>
</form>